<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id' :key='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const LPO_MODE = 'get_lpo_mode.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'lpoMode',
		data: function () { 
			return {
				selected: '',
				options: []
			}
		},
		props: {
			method: null
		},
		methods: {
			change () {
				EventBus.$emit(`lpo_mode`, this.selected)
			},
			getOptions (id) {
				fetch(DB + LPO_MODE + '?id=' + id, {
					credentials: 'include'
				})
				.then(data => data.json())
				.then(data => {
					if (data) {
						this.options = data
						this.selected = data[0].id
						this.change()
					}
					else {
						this.options = []
					}
				})
				.catch(err => console.log(err))
			}
		},
		created: function () {
			if(this.method) {
				this.getOptions(this.method)
			} else {
				EventBus.$on('lpo_method', id => {
					this.getOptions(id)
				})
			}
			
			/*EventBus.$on('lpo_method', id => {
				if(id == 1)
				{
					if(this.selected == 2)
					{
						this.selected = 1
						this.change()
					}
					this.remote_sensing = true
				}
				else
					this.remote_sensing = false
			})

			fetch(DB + LPO_MODE, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					this.selected = data[1].id //инструментальный
					this.change()
				}
				else {
					this.options = []
				}
			})
			.catch(err => console.log(err))*/
		},
		beforeDestroy() {
			EventBus.$off('lpo_method')
		}
	}
</script>


// WEBPACK FOOTER //
// lpoMode.vue?2a0d7f75